import { create } from "zustand";
import { AccountingSlice, createAccountingStore } from "./accounting.store";

interface AccountingStoreSlice extends AccountingSlice {}

export const useAccountingStore = create<AccountingStoreSlice>((...args) => ({
	...createAccountingStore(...args),
}));
